module.exports = __webpack_public_path__ + "static/media/mmf_pausenanimation_small_002.e4fd32af.png";